import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ASSET_LABELS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('ASSET_LABELS');
export const ASSET_LABELS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ASSET_LABELS_CRUD_ACTION_CONSTANTS
);
